"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../utils");

var _layout = require("../../layout");

var _context = require("../../context");

var _propTypes = require("../../prop-types");

var _link = require("../../link");

var _core = require("@emotion/core");

var styleCallback = function styleCallback(_ref) {
  var theme = _ref.theme,
      isSelected = _ref.isSelected,
      hasHover = _ref.hasHover;
  return {
    borderTop: '4px solid transparent',
    borderBottom: "4px solid ".concat(isSelected ? theme.selectors.color('neutral0') : 'transparent'),
    height: '100%',
    '&:focus': {
      outlineOffset: '-2px'
    },
    '&:hover': {
      backgroundColor: hasHover ? theme.selectors.color('primary70') : 'none',
      textDecoration: 'none'
    }
  };
};

var PageLinkWrapper = (0, _context.styledWithTheme)(_link.Link)(styleCallback);
var PageHeaderLinkDefaultProps = {
  paddingHorizontal: 'S300',
  hasHover: true,
  isSelected: false
};

var PageHeaderLinkWithoutDocs = function PageHeaderLinkWithoutDocs(_ref2) {
  var icon = _ref2.icon,
      dataTestId = _ref2.dataTestId,
      _ref2$paddingHorizont = _ref2.paddingHorizontal,
      paddingHorizontal = _ref2$paddingHorizont === void 0 ? PageHeaderLinkDefaultProps.paddingHorizontal : _ref2$paddingHorizont,
      children = _ref2.children,
      hasHover = _ref2.hasHover,
      isSelected = _ref2.isSelected,
      _ref2$wrapper = _ref2.wrapper,
      Wrapper = _ref2$wrapper === void 0 ? PageLinkWrapper : _ref2$wrapper,
      linkProps = (0, _objectWithoutProperties2.default)(_ref2, ["icon", "dataTestId", "paddingHorizontal", "children", "hasHover", "isSelected", "wrapper"]);
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactPageHeaderLink',
    dataTestId: dataTestId
  });
  return (0, _core.jsx)(Wrapper, (0, _extends2.default)({
    padding: [0, paddingHorizontal],
    fontWeight: "regular",
    textDecoration: "none",
    color: "neutral0",
    "aria-current": isSelected ? 'page' : 'false',
    isSelected: isSelected,
    hasHover: hasHover
  }, linkProps, dataTestProps), (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    gridGap: "S200",
    height: "100%"
  }, !!icon && icon, !!children && children));
};

var PageHeaderLinkStyled = PageHeaderLinkWithoutDocs;

PageHeaderLinkStyled.withComponent = function (tag) {
  var tagComponent = _link.Link.withComponent(tag, {
    target: "elyco8w0"
  });

  var Wrapper = (0, _context.styledWithTheme)(tagComponent)(styleCallback);
  return function (props) {
    return (0, _core.jsx)(PageHeaderLink, (0, _extends2.default)({}, props, {
      wrapper: Wrapper
    }));
  };
};

var PageHeaderLink = (0, _stencilReactDesc.describe)(PageHeaderLinkStyled).description('Link for page header.');
exports.PageHeaderLink = PageHeaderLink;
PageHeaderLink.displayName = 'PageHeaderLink';
PageHeaderLink.defaultProps = PageHeaderLinkDefaultProps;
PageHeaderLink.propTypes = {
  paddingHorizontal: (0, _propTypes.cssValue)().description('Sets the horizontal (left and right) padding.'),
  icon: _stencilReactDesc.PropTypes.node.description('Adds an icon to the left side of the link.'),
  children: _stencilReactDesc.PropTypes.node.description('Content of the link.'),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes."),
  isSelected: _stencilReactDesc.PropTypes.bool.description('Determines whether to add an indication that the link represents the currently selected page.')
};